import React from "react"
import { graphql } from "gatsby"
import "./_style.scss"

import Layout from "§/src/components/layout"
import Breadcrumb from "§/src/components/atoms/breadcrumb/breadcrumb"

import SchemaBreadcrumb from "§/src/components/schema/s-breadcrumb"
import SchemaPost from "§/src/components/schema/s-post"

import Error from "§/src/components/error"
import SEO from "§/src/components/seo"
import LoadingFrame from "§/src/components/atoms/loading-frame"

// Functions
import { isEmpty } from "lodash"
import HeaderSubContent from "§/src/components/atoms/content/header-sub-content"
import { GatsbyImage, getImage } from "gatsby-plugin-image"

// Components
import Layouter from "§/src/components/sections/layouter"
import RelatedProductsWithImage from "§/src/components/sections/related-products-with-image"
import CaseHistoryCarousel from "§/src/components/sections/case-history-carousel"
import TextModule from "§/src/components/atoms/content/text-module"
import ContactModalFloatingCta from "§/src/components/contact-modal-floating-cta"
import ContactModalFloatingCtaSalesforce from "§/src/components/contact-modal-floating-cta-salesforce"



import { getFormattedLanguage } from "§/src/utils/functions"

export function Head(props) {
  const seo = props?.pageContext?.seo || {}
  const post = props.pageContext
  const cptPosts = props?.pageContext?.acfPosts

  return (
    <React.Fragment>
      <html lang={getFormattedLanguage(process.env.GATSBY_SITE_LANG)}></html>
      <body className="post-news"></body>
      <SEO seo={seo} translations={props?.data?.lang?.translations}/>
      <SchemaBreadcrumb breadcrumbs={seo?.breadcrumbs} />
      <SchemaPost post={post} cptPosts={cptPosts} />
    </React.Fragment>
  )
}

const Post = props => {
  const cptPosts = props?.pageContext?.acfPosts
  const pageTitle = props.pageContext.title

  const compLayouter = cptPosts?.layouter ? translateToNewFormat(cptPosts?.layouter) : false
  const floatingCtas = props?.pageContext?.acfShared
  const floatingCta = floatingCtas?.floatingCta
  const enableSalesforce = floatingCtas?.enableSalesforce
  const pageUrl = props?.location?.href

  return (
    <Layout lang={props?.data?.lang?.translations}>
      <Breadcrumb
        wpseo={props?.pageContext?.seo?.breadcrumbs}
        base="News"
        className=""
      />

      {!isEmpty(props) ? (
        <React.Fragment>
          <HeaderSubContent
            title={props?.pageContext?.title}
            description={cptPosts?.subtitle}
          >
            <div className="d-flex gap-2">
              {props?.pageContext?.wpParent?.node?.title && (
                <div className="btn btn-sm btn-outline-dark b-light rounded-pill">
                  {props.pageContext.wpParent.node.title}
                </div>
              )}
            </div>
          </HeaderSubContent>

          {cptPosts?.relatedProducts && cptPosts?.mainImage && (
            <RelatedProductsWithImage
              mainImage={cptPosts?.mainImage}
              products={cptPosts?.relatedProducts}
            />
          )
          || (
            <div className="mb-3 main-image">
              <GatsbyImage
                image={getImage(cptPosts?.mainImage)}
                alt={cptPosts?.mainImage?.altText || ""}
              />
            </div>
          )}

          {cptPosts?.textModules && (
            <div className={"bg-full py-4 g-100"}>
              {cptPosts?.textModules &&
                cptPosts?.textModules.map((item, index) => {
                  return (
                    <TextModule
                      from="news-template"
                      key={"text-module-" + index}
                      pretitle={item?.preTitle}
                      title={item?.title}
                      content={item?.content}
                      downloadstitle={item?.downloads?.title}
                      downloadsfiles={item?.downloads?.downloadFiles}
                      reports={item?.reports}
                      className={"bg-full py-4 py-md-5 g-100"}
                    />
                  )
                })}
            </div>
          )}

          {compLayouter && (
            <div className="mt-7 mt-md-9">
              <Layouter data={compLayouter} from="news-template" />
            </div>
          )}

          {cptPosts?.relatedApplications && (
            <CaseHistoryCarousel
              className="product-chc"
              data={cptPosts?.relatedApplications}
            />
          )}

          {
            console.log('floatingCtas', floatingCtas)
          }

          {floatingCta === true && enableSalesforce === true ? (
            <ContactModalFloatingCtaSalesforce pageTitle={pageTitle} settings={floatingCtas} pageUrl={pageUrl} />
          ) : floatingCta === true && enableSalesforce !== true ? (
            <ContactModalFloatingCta pageTitle={pageTitle} settings={floatingCtas} />
          ) : null}

        </React.Fragment>
      ) : (
        <Error message="Something Went Wrong" />
      )}
    </Layout>
  )
}

export default Post


export const pageQuery = graphql`
  query GET_TRANSLATIONS($eq: String!) {
    lang : wpPost(slug: {eq: $eq}) {
      translations {
        postUrl
        siteId
      }
    }
  }
`

const translateToNewFormat = data => {
  if(data){
    data = [...data]
    for (const elem of data) {
      if (elem && elem.downloadFiles) {
        elem.downloadFiles = elem.downloadFiles.map(x => ({
          title: x.title,
          fieldGroupName: x.fieldGroupName,
          files: [{ ...x.file, title: x.title }],
          file: { ...x.file, title: x.title },
        }))
      }
      if (elem && elem.downloads && elem.downloads.downloadFiles) {
        elem.downloads.downloadFiles = elem.downloads.downloadFiles.map(x => ({
          title: x.title,
          fieldGroupName: x.fieldGroupName,
          files: [{ ...x.file, title: x.title }],
          file: { ...x.file, title: x.title },
        }))
      }
    }
    return data
  }
}
